import { render, staticRenderFns } from "./EquipView.vue?vue&type=template&id=08425c0b"
import script from "./EquipView.vue?vue&type=script&lang=js"
export * from "./EquipView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports